var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundImage: ("url(" + _vm.urlBodyBg + ")")})},[_c('div',{staticClass:"container product bg-white",staticStyle:{"min-height":"calc(100vh - 190px)"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }